// extracted by mini-css-extract-plugin
export default {"link":"aK-z","disabled":"bK-z"};